import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { HomePage } from '@/components/infoPages/HomePage'

const searchSchema = z.object({
  token: z.string().optional(),
  atoken: z.string().optional(),
})

export const Route = createFileRoute('/')({
  component: HomePage,
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const inviteToken = search.token ?? search.atoken
    if (inviteToken) {
      throw redirect({
        to: '/auth/invite',
        search: { token: inviteToken },
      })
    }
  },
})
